<template>
  <Verify />
</template>

<script lang="js">
import Verify from '@/components/verify/index.vue'

export default {
  name: 'VerifyPage',
  components: {
    Verify,
  }
}
</script>
<style lang="scss">
</style>